import { CreditBalanceInterface } from '@vendasta/billing';

export interface CreditBalance {
  merchantId: string;
  currency: string;
  amount: number;
}

export function creditBalanceFromApi(apiCreditBalance: CreditBalanceInterface): CreditBalance {
  return {
    merchantId: apiCreditBalance.merchantId || '',
    currency: apiCreditBalance.currency || '',
    amount: apiCreditBalance.amount || 0,
  };
}
